import { z } from "zod";

/// URL search params for the Kudos wall. Tab / query / sort live here so
/// refresh and share-links preserve the view (S3). All optional, defaults
/// are applied in the route component.

export const KUDOS_TAB_IDS = ["wall", "loved", "for-me", "from-me"] as const;
export const KUDOS_SORT_IDS = ["newest", "applauded"] as const;

export const kudosRouteSearchSchema = z
  .object({
    tab: z.enum(KUDOS_TAB_IDS).optional(),
    q: z.string().max(200).optional(),
    sort: z.enum(KUDOS_SORT_IDS).optional(),
    /// Relationship-board deep link: restrict to kudos exchanged with this
    /// counterpart. `counterpartName` labels the removable chip.
    counterpartId: z.string().optional(),
    counterpartName: z.string().optional(),
  })
  .strict();

export type KudosRouteSearch = z.infer<typeof kudosRouteSearchSchema>;
